<template>
  <p-autocomplete
    :minLength="1"
    :selectOnFocus="true"
    :suggestions="filter"
    ref="field"
    v-model="value"
  />
</template>
<script lang="ts">
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      value: null,
      suggestions: this.params.options.map(o => o[this.params.key]),
    };
  },
  computed: {
    filter() {
      return this.suggestions.filter(e => this.value && e.indexOf(this.value.toUpperCase()) > -1).slice(0, 100);
    }
  },
  mounted() {
    this.value = this.params.value;
  },
  methods: {
    getValue() {
      return this.value?.toUpperCase();
    },
  },
};
</script>
<style lang="scss">
.ag-popup-editor {
 .p-autocomplete-input.p-inputtext {
    padding: 0.53125rem;
    color: inherit;
    border: 0;
    box-shadow: none;
  }
}

</style>
